// Central client-side error logger. Quiet in production builds; logs to the
// console during development so engineers still see failures.
export const logError = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};
